import { useEffect, useLayoutEffect, useRef, useState } from "react";

export function useSlidePanel<T extends string>() {
  const anchorRef = useRef<HTMLDivElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);
  const [activePanel, setActivePanel] = useState<T | null>(null);
  const [panelDirection, setPanelDirection] = useState<"up" | "down">("up");

  const openPanel = (panel: T) => {
    if (activePanel === panel) {
      setActivePanel(null);
    } else {
      setPanelDirection("up");
      setActivePanel(panel);
    }
  };

  useLayoutEffect(() => {
    if (!activePanel || !panelRef.current || !anchorRef.current) return;
    const panelHeight = panelRef.current.scrollHeight;
    const toolbarTop = anchorRef.current.getBoundingClientRect().top;
    if (panelHeight > toolbarTop) {
      setPanelDirection("down");
    }
  }, [activePanel]);

  useEffect(() => {
    if (!activePanel) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (anchorRef.current && !anchorRef.current.contains(event.target as Node)) {
        setActivePanel(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activePanel]);

  return { anchorRef, panelRef, activePanel, setActivePanel, panelDirection, openPanel };
}
